"use client";

import React from "react";
import BaseTailoringQuestions, { TailoringQuestion } from "../shared/BaseTailoringQuestions";

interface ImpairmentTailoringQuestionsProps {
  onBack?: () => void;
}

const QUESTIONS: TailoringQuestion[] = [
  {
    id: "Impt-4",
    question: "Is there any significant degree of estimation uncertainty involved in any of the assumptions or methods?",
    type: "radio",
    options: ["Yes", "No"],
  },
  {
    id: "Impt-5",
    question: "Is there any significant management bias involved in any of the assumptions?",
    type: "radio",
    options: ["Yes", "No"],
  },
  {
    id: "Impt-6",
    question: "Has the management used any expert in arriving at the estimate?",
    type: "radio",
    options: ["Yes", "No"],
    follow_up: {
      condition: "Yes",
      id: "Impt-6-follow",
      question: "Have we used the work of management's expert as audit evidence?",
      type: "radio",
      options: ["Yes", "No"],
    },
  },
  {
    id: "Impt-7",
    question: "Have we used an expert to determine the recoverable amount/value-in-use as per the applicable financial reporting framework?",
    type: "radio",
    options: ["Yes", "No"],
  },
];

export default function ImpairmentTailoringQuestions({ onBack }: ImpairmentTailoringQuestionsProps) {
  return (
    <BaseTailoringQuestions
      areaName="Impairment Testing"
      title="Impairment Testing - Tailoring Questions"
      description="Answer entity-specific questions for Impairment Testing"
      questions={QUESTIONS}
      onBack={onBack}
    />
  );
}
